const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class PushCartRecommendedProducts extends window.BAO.CustomElement() {
  connectedCallback () {
    this.carousel = this.setupCarousel()

    this.setupCarousel()
  }

  setupCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 5,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 1.2,
              spacing: 5,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('push-cart-recommended-products')) {
  customElements.define(
    'push-cart-recommended-products',
    PushCartRecommendedProducts,
  )
}
